import React from "react";
import { Icon } from "../..";
import classNames from "classnames";
import { NavLink as _RouterNavLink } from "react-router-dom";
import { ReactRouterActionItem } from "./reactRouterHelper";
var RouterNavLink = _RouterNavLink;
export var ActionItem = function ActionItem(_ref) {
  var item = _ref.item;
  return item.icon ? item.linkProps ? React.createElement(RouterNavLink, Object.assign({
    component: ReactRouterActionItem
  }, item.linkProps, {
    disabled: item.disabled,
    exact: true
  }), item.icon && React.createElement(Icon, {
    icon: item.icon
  })) : React.createElement("li", {
    className: classNames("nav-icon-item", {
      active: item.active
    })
  }, React.createElement("a", {
    className: classNames("nav-icon", {
      disabled: item.disabled
    }),
    href: item.href,
    onClick: item.onClick
  }, React.createElement(Icon, {
    icon: item.icon
  }))) : null;
};